import type { AgentEvent, AgentEventType } from '../../../contracts/harness.types';
import { isRecord } from '../../../contracts/parse-utils';

export const parseAgentEvent = (data: string): AgentEvent | null => {
  if (!data.trim()) return null;

  let parsed: unknown;
  try {
    parsed = JSON.parse(data);
  } catch {
    return null;
  }

  if (!isRecord(parsed)) return null;
  if (parsed.schema_version !== 1) return null;
  if (typeof parsed.event_id !== 'string' || parsed.event_id === '') return null;
  if (typeof parsed.agent_run_id !== 'string' || parsed.agent_run_id === '') {
    return null;
  }
  if (typeof parsed.issued_at !== 'string' || parsed.issued_at === '') return null;
  if (typeof parsed.type !== 'string' || parsed.type === '') return null;

  return {
    ...parsed,
    type: parsed.type as AgentEventType,
  } as AgentEvent;
};
